import { FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import Footer from 'src/components/Footer';
import Header from 'src/components/Header';
import PageWrapper from 'src/components/PageWrapper';

import SectionBanner from 'src/pages/CertLanding/components/SectionBanner';
import SectionMain from 'src/pages/CertLanding/components/SectionMain';
import SectionQuestions from 'src/pages/CertLanding/components/SectionQuestions';
import SectionScreens from 'src/pages/CertLanding/components/SectionScreens';

import styles from './styles.less';

const CertLandingPageLayout: FC = () => (
    <PageWrapper>
        <Header />
        <main>
            <div className={styles.content}>
                <SectionMain />
                <SectionScreens />
                <SectionBanner />
                <SectionQuestions />
            </div>
        </main>
        <VSpacing default={80} />
        <Footer />
    </PageWrapper>
);

export default CertLandingPageLayout;
